import React from "react";
import Select, { components } from "react-select";

const SelectMenuButton = ({ actionButtonLabel, onClickActionButton, ...props }) => {
    const handleClick = (e) => {
        if (onClickActionButton) {
            onClickActionButton(e);
        }

        if (props.selectProps && props.selectProps.onMenuClose) {
            props.selectProps.onMenuClose();
        }
    };

    return (
        <components.MenuList {...props}>
            {props.children}
            <div className="flex p-8 border-top">
                <button
                    onClick={handleClick}
                    className="button -text"
                >
                    {actionButtonLabel}
                </button>
            </div>
        </components.MenuList>
    );
};

export const SelectActionList = (props) => {
    return (
        <Select
            {...props}
            inputId={props.name}
            placeholder="-- Select --"
            className={`${props.errorMessage ? "-error" : ""} react-select-container`}
            classNamePrefix="react-select"
            components={{
                MenuList: (menuListProps) => (
                    <SelectMenuButton
                        {...menuListProps}
                        actionButtonLabel={props.actionButtonLabel}
                        onClickActionButton={props.onClickActionButton}
                    />
                ),
            }}
        />
    );
};
